import {
  PROPERTY_LIST,
  ADD_PROPERTY,
  PROPERTY_FORM,
  PROPERTY_EDIT,
  GETPROPERTY_DETAIL,
  PROPERTY_FORM_UPDATE,
  PROPERTY_FILTER_LIST,
  PROPERTY_STATUS_UPDATE,
  PROPERTY_ERROR,
  PROPERTY_CONFIGURATION_LIST,
  PROPERTY_DOCUMENT_DELETE,
  PROPERTY_CHECK,
  SYNC_ALL_PROJECTS,
} from "../types";

const initialState = {
  response: null,
  detail: false,
  create: false,
};
const initialStateForm = {
  response: null,
  update: false,
};
const initialStateConfig = {
  response: null,
  update: false,
  detail: false,
  create: false,
};

export function propertyReducer(state = initialState, action) {
  switch (action.type) {
    case PROPERTY_CHECK:
      return {
        ...state,
        detail: false,
        create: false,
        propertyCheckresponse: action.payload,
      };
    case ADD_PROPERTY:
      return {
        ...state,
        detail: false,
        create: true,
        propertyCheckresponse: null,
        response: action.payload,
      };
    case PROPERTY_EDIT:
      return {
        ...state,
        detail: false,
        create: true,
        propertyCheckresponse: null,
        response: action.payload,
      };
    case GETPROPERTY_DETAIL:
      return {
        ...state,
        create: false,
        detail: true,
        response: action.payload,
      };
    case PROPERTY_FILTER_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };
    case PROPERTY_LIST:
      return {
        ...state,
        detail: false,
        create: false,
        response: action.payload,
      };
    case PROPERTY_STATUS_UPDATE:
      return {
        ...state,
        detail: false,
        create: true,
        response: action.payload,
      };
    case PROPERTY_DOCUMENT_DELETE:
      return {
        ...state,
        detail: false,
        create: true,
        deleteResponse: action.payload,
      };
    case SYNC_ALL_PROJECTS:
      return {
        ...state,
        detail: false,
        create: true,
        deleteResponse: action.payload,
      };
    case PROPERTY_ERROR:
      return {
        ...state,
        detail: true,
        create: true,
        response: action.payload,
      };
    default:
      return state;
  }
}

export function propertyFormReducer(state = initialStateForm, action) {
  switch (action.type) {
    case PROPERTY_FORM:
      return {
        ...state,
        update: false,
        response: action.payload,
      };
    case PROPERTY_FORM_UPDATE:
      return {
        ...state,
        update: true,
        response: action.payload,
      };

    default:
      return state;
  }
}
export function propConfiListReducer(state = initialStateConfig, action) {
  switch (action.type) {
    case PROPERTY_CONFIGURATION_LIST:
      return {
        ...state,
        detail: true,
        create: false,
        response: action.payload,
      };

    default:
      return state;
  }
}
